export const VersionsIcon = () => {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M4.98438 5.60135C4.98438 4.25878 6.07274 3.17041 7.41532 3.17041H9.79457C11.1371 3.17041 12.2255 4.25878 12.2255 5.60135C12.2255 6.94393 11.1371 8.03229 9.79457 8.03229H7.41532C6.07274 8.03229 4.98438 6.94393 4.98438 5.60135Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M15.0172 14.3939C15.0172 15.7364 13.9289 16.8248 12.5863 16.8248H11.345C10.0024 16.8248 8.91406 15.7364 8.91406 14.3939C8.91406 13.0513 10.0024 11.9629 11.345 11.9629H12.5863C13.9289 11.9629 15.0172 13.0513 15.0172 14.3939Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.4996 14.3882H15.0873M8.86183 14.3883H2.5"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2.5 5.60891H4.9122M12.3274 5.60889H17.4994"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
